export const MAX_LENGTH_REVIEWER_COMMENT = 1000
export const MAX_LENGTH_INTERNAL_COMMENT = 50

export const MAX_TASK_COMMENT_ROWS = 7
export const MAX_MIRUS_COMMENT_ROWS = 3

export const DIFF_DAYS_SWITCH_INPUT_TEST_ID = 'date-range-selection'
export const ABSENCE_TYPE_SELECT_TEST_ID = 'absence-type-select'
export const INDIVIDUAL_ABSENCE_TYPE_SELECT_TEST_ID = 'individual-absence-type-select'
export const TASK_COMMENT_INPUT_TEST_ID = 'reviewer-comment'
export const MIRUS_COMMENT_INPUT_TEST_ID = 'internal-comment'
